<template>
  <van-popup
    v-model="visible"
    :style="{ height: popupHeight + 'px' }"
    :position="'bottom'"
    :close-on-click-overlay="true"
    :round="true"
    get-container="body"
    @close="handleClose"
  >
    <div class="shop-detail-popup">
      <!-- 拖拽手柄 -->
      <div class="popup-top" 
        @touchstart.stop.prevent="onHandleTouchStart"
        @touchmove.stop.prevent="onHandleTouchMove"
        @touchend.stop.prevent="onHandleTouchEnd">
        <div
          class="popup-handle"
          
        ></div>
      </div>
      
      <!-- 头部 -->
      <div class="popup-header">
        <div class="header-left">
          <img :src="shopData.shop_cover || perIcon" alt="shop" class="shop-icon" />
        </div>
        <div class="header-content">
          <div class="shop-name">{{ shopData.name || '未知店铺' }}</div>
          <button class="navigate-btn" @click="handleNavigate">
            <span class="navigate-icon">✈</span>
            导航到这里
          </button>
        </div>
      </div>
      
      <!-- 标签页 -->
      <div class="popup-tabs">
        <div 
          class="tab-item" 
          :class="{ active: activeTab === 'intro' }"
          @click="activeTab = 'intro'"
        >
          简介
        </div>
        <div 
          class="tab-item" 
          :class="{ active: activeTab === 'info' }"
          @click="activeTab = 'info'"
        >
          详细信息
        </div>
      </div>
      
      <!-- 内容区域 -->
      <div class="popup-content">
        <!-- 简介标签页 -->
        <div v-show="activeTab === 'intro'" class="tab-content">
          <div class="content-section">
            <div class="section-content" v-html="shopData.introduction "></div>
          </div>
        </div>
        
        <!-- 详细信息标签页 -->
        <div v-show="activeTab === 'info'" class="tab-content">
          <div class="content-section"  v-if="shopData.kb_channel">
            <div class="section-title">口碑选购渠道</div>
            <img :src="shopData.kb_channel" alt="口碑选购渠道" class="kb-channel-img">
          </div>
          <div class="content-section" v-if="shopData.is_seasonal && shopData.season_start && shopData.season_end">
            <div class="section-title">时令季节</div>
            <div class="section-content">
              {{ shopData.season_start }}月 - {{ shopData.season_end }}月
            </div>
          </div>

          <div class="content-section"  v-if="shopData.tel_name">
            <div class="section-title">联系人</div>
            <div class="section-content">{{ shopData.tel_name  }}</div>
          </div>

          <div class="content-section" v-if="shopData.tel&& shopData.tel!=0">
            <div class="section-title">一键拨打电话</div>
            <div class="section-content">
              <a :href="`tel:${shopData.tel}`" class="tel-link">{{ shopData.tel }}</a>
              <!-- <span v-if="shopData.tel_name" class="tel-name">（{{ shopData.tel_name }}）</span> -->
            </div>
          </div>

          <div class="content-section">
            <div class="section-title">地址</div>
            <div class="section-content">{{ shopData.address || '暂无地址' }}</div>
          </div>
          
          
          
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
let perIcon = 'https://lbs-nfncb.nfncb.cn/gzmap/img/per.png'

export default {
  name: 'ShopDetailPopup',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    shopData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      activeTab: 'intro', // 当前激活的标签页：intro 或 info
      perIcon: perIcon,
      popupHeight: 0, // 弹窗高度（px）
      minPopupHeight: 0, // 最小高度
      maxPopupHeight: 0, // 最大高度
      dragging: false,
      dragStartY: 0,
      dragStartHeight: 0
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        // 打开弹窗时重置到简介标签页
        this.activeTab = 'intro'
        this.initPopupHeight()
      }
    }
  },
  methods: {
    initPopupHeight() {
      const viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 667
      this.minPopupHeight = viewportHeight * 0.4
      this.maxPopupHeight = viewportHeight * 0.9
      this.popupHeight = viewportHeight * 0.6
    },
    onHandleTouchStart(event) {
      if (!event.touches || !event.touches[0]) return
      this.dragging = true
      this.dragStartY = event.touches[0].clientY
      this.dragStartHeight = this.popupHeight || (typeof window !== 'undefined' ? window.innerHeight * 0.6 : 400)
    },
    onHandleTouchMove(event) {
      if (!this.dragging || !event.touches || !event.touches[0]) return
      const deltaY = this.dragStartY - event.touches[0].clientY
      let newHeight = this.dragStartHeight + deltaY
      if (this.minPopupHeight) {
        newHeight = Math.max(newHeight, this.minPopupHeight)
      }
      if (this.maxPopupHeight) {
        newHeight = Math.min(newHeight, this.maxPopupHeight)
      }
      this.popupHeight = newHeight
    },
    onHandleTouchEnd() {
      this.dragging = false
    },
    handleClose() {
      this.$emit('input', false)
    },
    handleNavigate() {
      const lat = parseFloat(this.shopData.lat)
      const lng = parseFloat(this.shopData.lng)
      
      // 验证坐标
      if (isNaN(lat) || isNaN(lng)) {
        this.$toast && this.$toast('坐标信息无效')
        return
      }
      
      // 检查是否在微信环境中
      const isWechat = /micromessenger/i.test(navigator.userAgent.toLowerCase())
      
      if (isWechat && typeof wx !== 'undefined') {
        // 在微信中，优先尝试使用微信地图API
        try {
          wx.openLocation({
            latitude: lat, // 纬度，浮点数，范围为90 ~ -90
            longitude: lng, // 经度，浮点数，范围为180 ~ -180
            name: this.shopData.name || '目的地', // 位置名
            address: this.shopData.address || '', // 地址详情说明
            scale: 18, // 地图缩放级别,整形值,范围从1~28。默认为最大
            infoUrl: '', // 在查看位置界面底部显示的超链接,可点击跳转
            success: () => {
              console.log('打开微信地图成功')
            },
            cancel: () => {
              console.log('用户取消打开微信地图')
            },
            fail: (res) => {
              console.error('打开微信地图失败:', res)
              // 如果权限验证中或失败，使用腾讯地图网页版
              if (res.errMsg && (res.errMsg.includes('permission') || res.errMsg.includes('offline verifying'))) {
                console.log('微信地图权限未配置，使用腾讯地图网页版')
                this.openTencentMap(lat, lng)
              } else {
                // 降级方案：使用腾讯地图网页版
                this.openTencentMap(lat, lng)
              }
            }
          })
        } catch (error) {
          console.error('调用微信地图API失败:', error)
          // 降级方案：使用腾讯地图网页版
          this.openTencentMap(lat, lng)
        }
      } else {
        // 不在微信中，使用腾讯地图网页版或唤起导航应用
        this.openTencentMap(lat, lng)
      }
    },
    // 打开腾讯地图（网页版或应用）
    openTencentMap(lat, lng) {
      const name = encodeURIComponent(this.shopData.name || '目的地')
      const address = encodeURIComponent(this.shopData.address || '')
      
      // 检测设备类型
      const ua = navigator.userAgent.toLowerCase()
      const isIOS = /iphone|ipad|ipod/.test(ua)
      const isAndroid = /android/.test(ua)
      
      // 腾讯地图 URL Scheme（优先）
      let tencentMapUrl = ''
      
      if (isIOS) {
        // iOS 腾讯地图 URL Scheme
        tencentMapUrl = `qqmap://map/routeplan?type=drive&to=${name}&tocoord=${lat},${lng}`
      } else if (isAndroid) {
        // Android 腾讯地图 URL Scheme
        tencentMapUrl = `qqmap://map/routeplan?type=drive&to=${name}&tocoord=${lat},${lng}`
      }
      
      // 腾讯地图网页版（降级方案）
      const webMapUrl = `https://apis.map.qq.com/uri/v1/routeplan?type=drive&to=${name}&tocoord=${lat},${lng}&referer=广州农业农村消费地图`
      
      // 先尝试打开腾讯地图应用
      if (tencentMapUrl) {
        try {
          const iframe = document.createElement('iframe')
          iframe.style.display = 'none'
          iframe.src = tencentMapUrl
          document.body.appendChild(iframe)
          
          // 设置超时，如果应用未安装，使用网页版
          setTimeout(() => {
            document.body.removeChild(iframe)
            // 如果应用未安装，打开网页版
            window.location.href = webMapUrl
          }, 500)
        } catch (error) {
          console.error('打开腾讯地图应用失败:', error)
          // 降级到网页版
          window.location.href = webMapUrl
        }
      } else {
        // 直接打开网页版
        window.location.href = webMapUrl
      }
    },
    // 唤起导航应用（其他地图应用）
    openNavigationApp(lat, lng) {
      const name = encodeURIComponent(this.shopData.name || '目的地')
      const address = encodeURIComponent(this.shopData.address || '')
      
      // 检测设备类型
      const ua = navigator.userAgent.toLowerCase()
      const isIOS = /iphone|ipad|ipod/.test(ua)
      const isAndroid = /android/.test(ua)
      
      // 导航链接列表（按优先级）
      const navUrls = []
      
      if (isIOS) {
        // iOS 优先使用高德地图
        navUrls.push(
          `iosamap://navi?sourceApplication=广州农业农村消费地图&poiname=${name}&lat=${lat}&lon=${lng}&dev=0`,
          `baidumap://map/direction?destination=${lat},${lng}&mode=driving&src=广州农业农村消费地图`,
          `qqmap://map/routeplan?type=drive&to=${name}&tocoord=${lat},${lng}`,
          `http://uri.amap.com/navigation?to=${lng},${lat}&toName=${name}&mode=car&policy=1&src=mypage&callapp=0`
        )
      } else if (isAndroid) {
        // Android 优先使用高德地图
        navUrls.push(
          `androidamap://navi?sourceApplication=广州农业农村消费地图&poiname=${name}&lat=${lat}&lon=${lng}&dev=0`,
          `baidumap://map/direction?destination=${lat},${lng}&mode=driving&src=广州农业农村消费地图`,
          `qqmap://map/routeplan?type=drive&to=${name}&tocoord=${lat},${lng}`,
          `http://uri.amap.com/navigation?to=${lng},${lat}&toName=${name}&mode=car&policy=1&src=mypage&callapp=0`
        )
      } else {
        // 其他平台使用通用链接
        navUrls.push(
          `http://uri.amap.com/navigation?to=${lng},${lat}&toName=${name}&mode=car&policy=1&src=mypage&callapp=0`
        )
      }
      
      // 尝试打开导航应用
      let opened = false
      for (let i = 0; i < navUrls.length; i++) {
        try {
          const iframe = document.createElement('iframe')
          iframe.style.display = 'none'
          iframe.src = navUrls[i]
          document.body.appendChild(iframe)
          
          // 设置超时，如果应用未安装，iframe 会失败
          setTimeout(() => {
            document.body.removeChild(iframe)
            if (!opened && i === navUrls.length - 1) {
              // 所有应用都未安装，使用通用链接或提示
              this.$toast && this.$toast('请安装导航应用（高德地图、百度地图或腾讯地图）')
            }
          }, 1000)
          
          opened = true
          break
        } catch (error) {
          console.error('打开导航应用失败:', error)
        }
      }
      
      // 如果所有应用都未安装，触发导航事件（由父组件处理）
      if (!opened) {
        this.$emit('navigate', {
          lat: this.shopData.lat,
          lng: this.shopData.lng,
          name: this.shopData.name,
          address: this.shopData.address
        })
      }
    }
  }
}
</script>

<style scoped>
.shop-detail-popup {
  height: 100%;
  width: 10rem;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 0 20px;
}

.popup-handle {
  width: 60px;
  height: 6px;
  background-color: #e0e0e0;
  border-radius: 3px;
  margin: 12px auto;
  touch-action: none;
  cursor: grab;
}

.popup-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;
}

.header-left {
  flex-shrink: 0;
}

.shop-icon {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: cover;
  background-color: #f0f0f0;
}

.header-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.shop-name {
  font-size: 32px;
  font-weight: 500;
  color: #333;
  line-height: 1.4;
}

.navigate-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  background-color: #1989fa;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 28px;
  cursor: pointer;
  transition: background-color 0.2s;
  align-self: flex-start;
}

.navigate-btn:active {
  background-color: #0570c9;
}

.navigate-icon {
  font-size: 24px;
}

.popup-tabs {
  display: flex;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 16px;
}

.tab-item {
  flex: 1;
  padding: 16px 0;
  text-align: center;
  font-size: 30px;
  color: #666;
  cursor: pointer;
  position: relative;
  transition: color 0.2s;
}

.tab-item.active {
  color: #1989fa;
  font-weight: 500;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #1989fa;
}

.popup-content {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 20px;
}

.tab-content {
  min-height: 100%;
}

.content-section {
  margin-bottom: 24px;
}

.section-title {
  font-size: 28px;
  font-weight: 500;
  color: #333;
  margin-bottom: 12px;
}

.section-content {
  font-size: 28px;
  color: #666;
  line-height: 1.6;
  word-break: break-all;
}

.section-content.secondary-classify {
  margin-top: 8px;
  color: #999;
  font-size: 24px;
}

.tel-link {
  color: #1989fa;
  text-decoration: none;
}

.tel-link:active {
  opacity: 0.7;
}

.tel-name {
  color: #999;
  font-size: 24px;
  margin-left: 8px;
}
.kb-channel-img {
  width: 200px;
}

/* 处理 HTML 内容样式 */
:deep(.section-content) {
  font-size: 28px;
  color: #666;
  line-height: 1.6;
}

:deep(.section-content p) {
  margin: 8px 0;
}

:deep(.section-content img) {
  max-width: 100%;
  height: auto;
}
</style>

